import maintenance from '@/api/maintenance';

import {
    GET_MAINTENANCE_PLAN_LIST_BEGIN,
    GET_MAINTENANCE_PLAN_LIST_SUCCESS,
    GET_MAINTENANCE_PLAN_LIST_FAILURE,
    GET_MAINTENANCE_TASK_LIST_BEGIN,
    GET_MAINTENANCE_TASK_LIST_SUCCESS,
    GET_MAINTENANCE_TASK_LIST_FAILURE,
    CREATE_MAINTENANCE_TASK_BEGIN,
    CREATE_MAINTENANCE_TASK_SUCCESS,
    CREATE_MAINTENANCE_TASK_FAILURE,
    UPDATE_MAINTENANCE_TASK_BEGIN,
    UPDATE_MAINTENANCE_TASK_SUCCESS,
    UPDATE_MAINTENANCE_TASK_FAILURE,
    DELETE_MAINTENANCE_TASK_BEGIN,
    DELETE_MAINTENANCE_TASK_SUCCESS,
    DELETE_MAINTENANCE_TASK_FAILURE,
} from './types';

const initialState = {
    taskList: false,
    taskListError: false,
    taskError: false,
    planList: false,
    planListError: false,
};

const getters = {
    taskList: (state) => state.taskList,
    taskListError: (state) => state.taskListError,
    taskError: (state) => state.taskError,
    planList: (state) => state.planList,
    planListError: (state) => state.planListError,
};

const actions = {
    getTaskList({ commit }, filter) {
        commit(GET_MAINTENANCE_TASK_LIST_BEGIN);
        return maintenance.getTaskList(filter)
            .then((response) => commit(GET_MAINTENANCE_TASK_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_MAINTENANCE_TASK_LIST_FAILURE, error.response?.data || error));
    },
    createTask({ commit }, data) {
        commit(CREATE_MAINTENANCE_TASK_BEGIN);
        return maintenance.createTask(data)
            .then(() => commit(CREATE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(CREATE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    updateTask({ commit }, { id, data }) {
        commit(UPDATE_MAINTENANCE_TASK_BEGIN);
        return maintenance.updateTask(id, data)
            .then(() => commit(UPDATE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(UPDATE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    deleteTask({ commit }, id) {
        commit(DELETE_MAINTENANCE_TASK_BEGIN);
        return maintenance.deleteTask(id)
            .then(() => commit(DELETE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(DELETE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    assignTask({ commit }, { id, assignee }) {
        commit(UPDATE_MAINTENANCE_TASK_BEGIN);
        return maintenance.assignTask(id, { assignee })
            .then(() => commit(UPDATE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(UPDATE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    completeTask({ commit }, { id, report }) {
        commit(UPDATE_MAINTENANCE_TASK_BEGIN);
        return maintenance.completeTask(id, { report })
            .then(() => commit(UPDATE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(UPDATE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    cancelTask({ commit }, { id, reason }) {
        commit(UPDATE_MAINTENANCE_TASK_BEGIN);
        return maintenance.cancelTask(id, { reason })
            .then(() => commit(UPDATE_MAINTENANCE_TASK_SUCCESS))
            .catch((error) => commit(UPDATE_MAINTENANCE_TASK_FAILURE, error.response?.data || error));
    },
    getPlanList({ commit }, filter) {
        commit(GET_MAINTENANCE_PLAN_LIST_BEGIN);
        return maintenance.getPlanList(filter)
            .then((response) => commit(GET_MAINTENANCE_PLAN_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_MAINTENANCE_PLAN_LIST_FAILURE, error.response?.data || error));
    },
};

const mutations = {
    [GET_MAINTENANCE_TASK_LIST_BEGIN](state) {
        state.taskListError = false;
    },
    [GET_MAINTENANCE_TASK_LIST_SUCCESS](state, data) {
        state.taskList = data;
    },
    [GET_MAINTENANCE_TASK_LIST_FAILURE](state, error) {
        state.taskListError = error;
    },
    [CREATE_MAINTENANCE_TASK_BEGIN](state) {
        state.taskError = false;
    },
    [CREATE_MAINTENANCE_TASK_SUCCESS]() {},
    [CREATE_MAINTENANCE_TASK_FAILURE](state, error) {
        state.taskError = error;
    },
    [UPDATE_MAINTENANCE_TASK_BEGIN](state) {
        state.taskError = false;
    },
    [UPDATE_MAINTENANCE_TASK_SUCCESS]() {},
    [UPDATE_MAINTENANCE_TASK_FAILURE](state, error) {
        state.taskError = error;
    },
    [DELETE_MAINTENANCE_TASK_BEGIN](state) {
        state.taskError = false;
    },
    [DELETE_MAINTENANCE_TASK_SUCCESS]() {},
    [DELETE_MAINTENANCE_TASK_FAILURE](state, error) {
        state.taskError = error;
    },
    [GET_MAINTENANCE_PLAN_LIST_BEGIN](state) {
        state.planListError = false;
    },
    [GET_MAINTENANCE_PLAN_LIST_SUCCESS](state, data) {
        state.planList = data;
    },
    [GET_MAINTENANCE_PLAN_LIST_FAILURE](state, error) {
        state.planListError = error;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
